import SubmenuProvider from './hooks/useSubmenu';

import { SubmenuProps } from './@types/SubmenuProps';
import SubMenuContainer from './handles/SubMenuContainer';
import SubMenuWrapper from './handles/SubMenuWrapper';

const Submenu = (props: SubmenuProps) => (
	<SubmenuProvider {...props}>
		<SubMenuContainer>
			<SubMenuWrapper>
				<section className={`vtex-menu-2-x-submenu submenu w-100 flex justify-center`}>{props.children}</section>
			</SubMenuWrapper>
		</SubMenuContainer>
	</SubmenuProvider>
);

export default Submenu;
